export default "https://cdn-static.gokick.com/assets/a067049b7600101c8dd9c58c97ab0ac81c37d227/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";